import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { Buhin } from '@/models/Buhin';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class BuhinsService {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getBuhins(version: number, param: any, sknInspectSeibiFeeId: any = null) {
        let q = "";
        let query: string[] = [];
        if (param) {
            Object.keys(param).forEach((key: string) => {
                if (param[key]) {
                    query.push(`${key}=${param[key]}`);
                }
            });
        }
        if (sknInspectSeibiFeeId) {
            query.push(`sknInspectSeibiFeeId=${sknInspectSeibiFeeId}`);
        }
        if (query.length) {
            q = `?${query.join("&")}`;
        }
        const { result, error } = await this.commonService.get(version
            ? `${this.baseAPI}/buhin/${version}${q}`
            : `${this.baseAPI}/buhin${q}`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getBuhins');
            return;
        }
    }

    public async editBuhins(data: Buhin) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/buhin/`, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editBuhins');
            return;
        }
    }

    public async addBuhins(data: Buhin, version: any, param: any) {
        let path = `${this.baseAPI}/buhin`;
        if (version) {
            path += `/${version}`;
        } else if (param) {
            let q = "";
            let query: string[] = [];
            Object.keys(param).forEach((key: string) => {
                if (param[key]) {
                    query.push(`${key}=${param[key]}`);
                }
            });
            if (query.length) {
                q = `?${query.join("&")}`;
            }
            path += q;
        }
        const { result, error } = await this.commonService.post(path, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'addBuhins');
            return;
        }
    }

    public async deleteBuhins(id: number, sknInspectSeibiFeeId: number) {
        let q = "";
        if (sknInspectSeibiFeeId) {
            q = `?sknInspectSeibiFeeId=${sknInspectSeibiFeeId}`;
        }
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/buhin/${id}${q}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteBuhins');
            return;
        }
    }

    public async saveBuhins(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/buhin-order-display`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async getBuhinBunrui() {
        let path = `${this.baseAPI}/buhinBunrui`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getBuhinBunrui');
            return;
        }
    }

    public async getSeibi(version?: number,workCd?: string, title?: string) {
        let path = `${this.baseAPI}/seibi`;
        if(version) {
            path += `/${version}`;
        }
        let arrQ = [];
        if (workCd) {
            arrQ.push("workCd=" + workCd);
        }
        if (title) {
            arrQ.push("title=" + title);
        }
        let q = "";
        if (arrQ.length > 0) {
            q = "?" + arrQ.join("&");
        }
        const { result, error } = await this.commonService.get(path + q);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getSeibi');
            return;
        }
    }

    public async saveBuhinLink(data: any, versionId: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/buhin-link?versionId=${versionId}`
        , data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    // ============================

    public async updateImportKbn(data: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/seibi/import-kbn`, data);
        if (result) {
          return result.status;
        } else {
          this.authService.handleError(error, 'updateImportKbn');
          return;
        }
      }


    public async updateExpImportKbn(data: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/seibi/exp-import-kbn`, data);
        if (result) {
          return result.status;
        } else {
          this.authService.handleError(error, 'updateExpImportKbn');
          return;
        }
      }



}
